module.exports = __webpack_public_path__ + "img/unmanned.c5956e41.png";